<script>
  import {
    validateName,
    validateEmail,
    validateMessage,
    validateDate,
  } from "./utils/validators";

  import { jsonToQueryString } from "./utils/helpers";

  let name = "",
    subject = "",
    email = "",
    date = "",
    year = "",
    month = "",
    day = "",
    message = "",
    nameIsValid = true,
    emailIsValid = true,
    dateIsValid = true,
    messageIsValid = true,
    formSubmitted = false;

  function onDateChange() {
    const date_parts = date.split("/").join("-").split("-");
    day = date_parts[0];
    month = date_parts[1];
    year = date_parts[2];
  }

  function validateFields() {
    nameIsValid = validateName(name);
    emailIsValid = validateEmail(email);
    messageIsValid = validateMessage(message);
    if (date != "") {
      dateIsValid = validateDate(date);
    } else {
      dateIsValid = true;
    }
    return nameIsValid && emailIsValid && message && dateIsValid;
  }

  function postToJotform() {
    const post_url = "https://submit.jotform.com/submit/201346760077151/"; //production JotForm
    // const post_url = "https://submit.jotform.com/submit/201665524765157/" //Test JotForm for development
    const payload = {
      q5_name: name,
      q9_subject: subject,
      q6_email: email,
      "q10_date[year]": year,
      "q10_date[month]": month,
      "q10_date[day]": day,
      q7_message: message,
    };
    if (validateFields()) {
      fetch(post_url, {
        body: jsonToQueryString(payload),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
      }).then((res) => console.log(res.text()));
      formSubmitted = true;
    }
  }
</script>

<style>
  label {
    display: inline;
    font-size: 16px;
    font-weight: 700;
  }
  .l-inputs {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding: 0 90px 0 4%;
  }
  .l-input {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 451px;
  }
  .l-input:not(:last-child) {
    margin-bottom: 47px;
  }
  .input_footnote {
    position: absolute;
    right: 0;
    bottom: -18px;
    font-size: 8px;
    font-weight: 600;
  }
  input {
    width: 373px;
    height: 44px;
    margin: 0;
    text-indent: 15px;
  }
  input::placeholder {
    color: #1b222580;
  }
  /* Calendar placeholder text, bleh */
  input::-webkit-datetime-edit-day-field,
    input::-webkit-datetime-edit-month-field,
    input::-webkit-datetime-edit-year-field,
    input::-webkit-datetime-edit-text, /* this makes the slashes in dd/mm/yyyy grey */
    input::-webkit-datetime-edit {
    text-indent: 5px; /* bleh*/
  }

  .l-casey-form {
    width: 100%;
  }

  .l-form-heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 70px 0;
    height: 150px;
    font-size: 24px;
    letter-spacing: 4px;
  }

  .casey-form {
    display: flex;
    height: 424px;
    justify-content: space-between;
  }
  .l-message {
    background: #1b2225;
    width: calc(50% + 45px);
    color: white;
    padding: 48px 23px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  #event_date {
    width: 196px;
  }

  .event_date-label {
    white-space: nowrap;
  }

  #input_7 {
    background: #1b2225;
    color: white;
    width: 100%;
    height: 234px;
    max-height: 234px;
    border: none;
    margin: 0;
    padding: 0;
    letter-spacing: 0.7px;
    resize: none;
  }
  #input_7::placeholder {
    color: white;
    font-size: 12px;
    font-style: italic;
  }
  .textarea-label {
    display: block;
    margin: 0 0 20px 0;
  }
  .l-message__submit {
    border-top: 1px solid white;
  }
  .l-message_length {
    position: relative;
    text-align: right;
    font-size: 8px;
    margin-top: 1.5em;
  }
  button.submit {
    display: inline-block;
    border: none;
    padding: 0;
    margin: 0;
    text-decoration: none;
    background: #1b2225;
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 2px;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    text-align: center;
    transition: color 250ms ease-in-out;
  }

  button.submit:hover {
    color: #d7d7d7;
  }
  .thankyou {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 20%;
  }
  /* tablet */
  @media only screen and (max-width: 1024px) {
    .l-casey-form {
      margin: 0 80px;
      width: auto;
    }
    .casey-form {
      flex-direction: column;
      height: 100%;
    }
    .l-inputs {
      width: auto;
      align-items: flex-start;
      padding: 0;
    }
    .l-input {
      max-width: 502px;
    }
    input {
      width: 423px;
    }
    .l-message {
      width: auto;
    }
    .l-form-heading {
      height: 130px;
      margin: 70px 0 56px;
    }
    .l-form-heading h2 {
      font-size: 32px;
      font-weight: 800;
    }
    .l-message {
      margin: 40px 0 0;
    }
    #event_date {
      width: 245px;
    }
  }
  @media only screen and (max-width: 640px) {
    .l-casey-form {
      margin: 0 17px;
    }
    .l-inputs {
      padding: 0;
    }
    .l-input {
      flex-direction: column;
      max-width: none;
    }
    .l-input:not(:last-child) {
      margin-bottom: 28px;
    }

    input {
      margin: 0;
      width: 100%;
    }
    label {
      align-self: flex-start;
      margin: 0 0 10px 0;
    }
    .l-form-heading {
      height: 114px;
      margin: 50px 0;
    }
    .l-form-heading h2 {
      font-size: 24px;
    }
    #event_date {
      width: 250px;
      align-self: flex-start;
    }
  }
</style>

<!-- <svelte:window on:keyup={validateFields}/> -->

<section class="l-casey-form">
  <div class="l-form-heading">
    <img src="images/cc-logo.svg" alt="casey crawford logo" />
    <h2>GET IN TOUCH</h2>
  </div>
  <form class="casey-form" on:submit|preventDefault={null}>
    {#if !formSubmitted}
      <div class="l-inputs">
        <div class="l-input">
          <label class="" id="label_5" for="input_5">Name</label>
          <input bind:value={name} type="text" id="input_5" name="q5_name" />
          {#if !nameIsValid}
            <div class="input_footnote" style="color:red;">Invalid</div>
          {/if}
        </div>
        <div class="l-input">
          <label class="" id="label_9" for="input_9">Subject</label>
          <input
            bind:value={subject}
            type="text"
            id="input_9"
            name="q9_subject"
            maxLength="25"
            placeholder="This is the subject of the message" />
          <div class="input_footnote">{subject.length}/25</div>
        </div>
        <div class="l-input">
          <label class="" id="label_6" for="input_6">Email</label>
          <input
            bind:value={email}
            type="email"
            id="input_6"
            name="q6_email"
            placeholder="example@example.com" />
          {#if !emailIsValid}
            <div class="input_footnote" style="color:red;">Invalid</div>
          {/if}
        </div>
        <div class="l-input">
          <label class="event_date-label" id="label_6" for="event_date">
            Event Date (If Applicable)
          </label>
          <input
            bind:value={date}
            type="date"
            id="event_date"
            name="event_date"
            placeholder="mm/dd/yyyy"
            on:change={onDateChange} />
            <!-- date!=  -->
            {#if !dateIsValid  && date != ""}
            <div class="input_footnote" style="color:red;">Invalid</div>
          {/if}
        </div>
      </div>
      <div class="l-message" id="id_7">
        <div>
          <label class="textarea-label" id="label_7" for="input_7">
            Message
            {#if !messageIsValid}
              <span class="input_footnote" style="color:red;position:static;">
                Invalid
              </span>
            {/if}
          </label>

          <div id="cid_7" class="">
            <textarea
              bind:value={message}
              maxLength="250"
              id="input_7"
              class="form-textarea validate[required]"
              name="q7_message"
              placeholder="Start Writing..." />
          </div>
        </div>
        <div class="l-message__submit">
          <div class="l-message_length">
            <div>{message.length}/250</div>
          </div>
          <button class="submit" on:click={postToJotform}>SUBMIT &rarr;</button>
<!-- {
  validateName,
    validateEmail,
    validateMessage,
    validateDate,
    jsonToQuerySt}>SUBMIT &rarr;</button> --> -->
        </div>
      </div>
    {:else}
      <div class="thankyou">
        <h2>Thank You!</h2>
        <p>
          Thank you for contacting Casey through caseycrawford.com. Casey and
          his team appreciate your interest in his mission to love and value
          people by leading a movement of change! We will be sure to pass your
          message along to Casey for his consideration. Thank you!
        </p>
      </div>
    {/if}
  </form>

</section>
